
export class BundleScanRequest {
    unitId: string;
    barcode: string;
    operation: string;
    username: string;

    constructor(unitId: string,
        barcode: string,
        operation: string,
        username: string) {
            this.unitId = unitId;
            this.barcode = barcode;
            this.operation = operation;
            this.username = username;
    }
}
